import RoutesMap from "route_control/RouteControl"
import { PaymentList, ChargesList } from "pages/payments"

const PaymentsRoute = () => {
    return [
        {
            path: RoutesMap.PAYMENT_LIST.path,
            element: <PaymentList />
        },
        {
            path: RoutesMap.CHARGES_LIST.path,
            element: <ChargesList />
        },
    ]
}

export default PaymentsRoute;
